import { makeStyles } from '@material-ui/core/styles';
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Badge, Box, Divider, Menu, MenuItem, Typography } from 'components/AORedesign';
import { useNewsArticleModal } from 'hooks/useNewsArticleModal';
import NewsArticleModal from 'components/NewsArticles/NewsArticleModal';
import { ANNOUNCEMENT_TYPES } from 'constants/static';
import { selectAnnouncements } from 'redux/app-store';

const useStyles = makeStyles(() => ({
  iconContainer: {
    cursor: 'pointer',
  },
  menu: { maxHeight: '80%', width: '500px', zIndex: '1400 !important' },
  menuText: { whiteSpace: 'normal' },
  menuContent: { width: '400px' },
}));

const BellAlerts = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const { announcements: alerts } = useSelector((state) => selectAnnouncements(state, [ANNOUNCEMENT_TYPES.ALERT_REGULAR, ANNOUNCEMENT_TYPES.ALERT_URGENT]));

  // shared news-article modal: fetch-on-open + pdf/doc download branching
  const { openNewsArticle, newsArticleModalProps } = useNewsArticleModal();

  const handleEventClick = (event) => {
    if (alerts.length > 0) setAnchorEl(event.currentTarget);
  };

  const handleCloseMenuPopup = () => {
    setAnchorEl(null);
  };

  const handleOpenNewsItem = (id, ext) => {
    handleCloseMenuPopup();
    openNewsArticle(id, ext);
  };

  return (
    <>
      {alerts && (
        <Box p={0.5} className={alerts.length > 0 ? classes.iconContainer : ''} onClick={(event) => handleEventClick(event)}>
          {alerts.length > 0 && (
            <Badge
              color="error"
              variant="dot"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}>
              <NotificationsOutlinedIcon color="primary" />
            </Badge>
          )}
          {alerts.length < 1 && <NotificationsOutlinedIcon color="primary" />}
        </Box>
      )}
      <Menu
        id="bell-alerts"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenuPopup}
        className={classes.menu}
        anchorOrigin={{
          vertical: 55,
          horizontal: 'left',
        }}
        getContentAnchorEl={null}>
        <Box px={2} my={2}>
          <Typography variant="h6">Alerts</Typography>
        </Box>
        {alerts &&
          alerts.map((alert, index) => {
            return (
              <Box key={`${alert.seqId}-${index}`}>
                <Divider />
                <MenuItem onClick={() => handleOpenNewsItem(alert.seqId, alert.ext)} className={classes.menuText}>
                  <Box className={classes.menuContent} py={1}>
                    <Typography>{alert.title}</Typography>
                  </Box>
                </MenuItem>
              </Box>
            );
          })}
      </Menu>
      <NewsArticleModal {...newsArticleModalProps} />
    </>
  );
};

export default BellAlerts;
